import { FileIcon } from 'lucide-react';
import { ChartNote } from '../../api/types';
import {
  VStack,
} from '@ayble-health/dashboard-components';
import { Button } from 'components/ui/button';

type Props = {
  chartNotes?: ChartNote[];
  onClick: (chartNote: ChartNote) => void;
};

export const UpcomingMeetingChartNotes = ({
  chartNotes = [],
  onClick,
}: Props) => {
  return (
    <VStack gap={2} mt={2}>
      {chartNotes.map((chartNote) => {
        return (
          <Button
            size={'md'}
            key={chartNote.note_id}
            variant={'outline'}
            onClick={() => onClick(chartNote)}
          >
            <FileIcon />
            {chartNote.note_type}
          </Button>
        );
      })}
    </VStack>
  );
};

export default UpcomingMeetingChartNotes;
